/** 一括生成の最大数 */
export const GENERATE_LIMIT = 20;
